// extracted by mini-css-extract-plugin
export default {"spinner-content":"ClaimDepartment_spinner-content__uIulC","spinner":"ClaimDepartment_spinner__OyMRQ"};